import { GridColumnVisibilityModel } from '@microservices/wiskey-react-table-component'

export const normalizeColumnVisibilityModel = (
  model: GridColumnVisibilityModel,
  fieldCodes: string[]
): GridColumnVisibilityModel =>
  Object.fromEntries(fieldCodes.map(field => [field, model[field] !== false]))
